import { toByteArray, fromByteArray } from 'base64-js'

export function encode (data) {
  return fromByteArray(Buffer.from(JSON.stringify(data), 'utf8'))
}

export function decode (string) {
  return JSON.parse(Buffer.from(toByteArray(string)).toString('utf8'))
}



// WEBPACK FOOTER //
// ./resources/assets/js/query-encoder.js